import React from "react";
import Development from "../../features/development/Development";

export default function DevelopmentPage() {
  return (
    <div>
      <Development />
    </div>
  );
}
